import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Container from "./Container";
import loader from "../images/loader/loader1.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PiEngineFill } from "react-icons/pi";
import { FaCar } from "react-icons/fa";
import { FaRoad } from "react-icons/fa";
import { RiSteering2Fill } from "react-icons/ri";
import { GiGasPump } from "react-icons/gi";


function countWords(text) {
  return text.split(/\s+/).filter(word => word !== "").length;
}

const NewArrivals = () => {
  const productState = useSelector((state) => state.product.product);
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const isTitleTooLong = productState?.some(item => countWords(item?.title) > 10);
  const servicesRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProducts());
  }, [dispatch]);


const handleProductView = (product) => {
  if (product.availability === "Out of Stock") return;
  navigate(`/vehicle/${product.slug}`);
};

  console.log(productState,"products")

    useEffect(() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top <
          window.innerHeight / 1.15;

        if (elementIsInScreen) {
          revealElements[i].classList.add("revealed");
        } else {
          revealElements[i].classList.remove("revealed");
        }
      }
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();

    return () => {
      window.removeEventListener("scroll", scrollReveal);
    };
  }, []);

  return (
    <div className="featured-wrapper home-wrapper-2" ref={servicesRef}>
      <div className="top-header featured__header">
      <span data-reveal>Featured  </span>
      <h3 data-reveal>Explore Our Featured Cars</h3>

        <div className="line-wrapper" data-reveal>
          <div className="short-line"></div>
           <div className="short-line"></div>

        </div>  

      </div>
      <div className={`featured-collection ${isDesktop ? "featured" : ""}`}>
        {productState &&
          productState
            .filter((item) => item.tags === "featured")
            .slice(0, 12)
            .map((item, index) => (
              <div key={index} className="product-wrapper-el-1">
                <div
                  className="product-card position-relative"
                  onClick={() => handleProductView(item.slug)}
                >
                  <div className="product-image new-arrivals-img-container ">
                    {item?.availability === "Out of Stock" && (
                  <div className="sold-badge">
                    SOLD
                  </div>
                )}
                    <LazyLoadImage
                      alt={item?.title}
                      title={item?.title}
                      effect="blur"
                      src={item?.images[0]?.url || loader}
                      placeholderSrc={loader}
                      width="100%"
                      height={isDesktop ? 250 : "100%"}
                      loading="lazy"
                      className="img-fluid mx-auto img-el"
                    />
                  </div>
            <div className="product-details">
              <h5 className="product-title ellipsis" >
                {item?.title}
              </h5>
            <div className="features">
              <span className="feature-item">
                <RiSteering2Fill className="feature-icon"/> 
                <span className="feature-text">{item?.transmission}</span>
              </span>

              <span className="feature-item">
                <PiEngineFill className="feature-icon"/> 
                <span className="feature-text">{item?.engineSize[0]?.title}</span>
              </span>

              <span className="feature-item">
                <FaCar className="feature-icon"/> 
                <span className="feature-text">{item?.yom}</span>
              </span>

              <span className="feature-item">
                <GiGasPump className="feature-icon"/> 
                <span className="feature-text">{item?.fuelType}</span>
              </span>
            </div>

                    <div className="price-wrapper">
                      <p className="nw-price">KES {item?.price.toLocaleString()}</p>
                  {item?.availability === "Out of Stock" ? (
                    <button className="sold-button" disabled>
                      <span>Sold</span>
                    </button>
                  ) : (
                    <button className="view-button">
                      <span>Details</span>
                    </button>
                  )}
                    </div>

             
            </div>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default NewArrivals;
